<template>
  <el-form ref="formRef" :model="form" :rules="rules" :label-width="labelWidth || '120px'">
    <!-- 动态生成表单项 -->
      <el-row :gutter="20">
        <template v-for="(item, colIndex) in dynamicFormRows" :key="colIndex">
          <el-col :span="item.span || 8">
            <el-form-item :label="item.label" :prop="item.field" class="form-item">
              <!-- 输入框 -->
              <el-input
                v-if="item.type === 'input'"
                v-model="form[item.field]"
                :placeholder="item.placeholder"
                :disabled="disabled(item.field)"
                class="custom-input"
              ></el-input>
              <el-input
                v-if="item.type === 'password'"
                type="password" 
                v-model="form[item.field]"
                :placeholder="item.placeholder"
                :disabled="disabled(item.field)"
                class="custom-input"
              ></el-input>
              <!-- 数字框 -->
              <el-input-number
                v-if="item.type === 'number'"
                v-model="form[item.field]"
                :disabled="disabled(item.field)"
                class="custom-input custom-input-number"
              ></el-input-number>
              <!-- 日期框 -->
              <el-date-picker
                v-if="item.type === 'date'"
                v-model="form[item.field]"
                type="date"
                :placeholder="item.placeholder"
                :disabled="disabled(item.field)"
                class="custom-input"
                :format="item.format || 'YYYY-MM-DD'"
                :value-format="item.format || 'YYYY-MM-DD'"
              ></el-date-picker>
              <!-- 日期范围框 -->
              <el-date-picker
                v-if="item.type === 'dateRange'"
                v-model="form[item.field]"
                type="daterange"
                range-separator="至"
                :start-placeholder="item.startPlaceholder"
                :end-placeholder="item.endPlaceholder"
                :disabled="disabled(item.field)"
                :format="item.format || 'YYYY-MM-DD'"
                :value-format="item.format || 'YYYY-MM-DD'"
                class="custom-input"
              ></el-date-picker>
              <!-- 时间范围框 -->
              <el-time-picker
                v-if="item.type === 'timeRange'"
                v-model="form[item.field]"
                is-range
                range-separator="至"
                :start-placeholder="item.startPlaceholder"
                :end-placeholder="item.endPlaceholder"
                :disabled="disabled(item.field)"
                :format="item.format || 'HH:mm:ss'"
                :value-format="item.format || 'HH:mm:ss'"
                class="custom-input"
              />
              <!-- 下拉框 -->
              <el-select
                v-if="item.type === 'select'"
                v-model="form[item.field]"
                :multiple = "item.isMultiple || false"
                :placeholder="item.placeholder"
                :disabled="disabled(item.field)"
                class="custom-input"
              >
                <el-option
                  v-for="option in item.options"
                  :key="option.code"
                  :label="option.text"
                  :value="option.code"
                ></el-option>
              </el-select>
              <!-- 单选框 -->
              <el-radio-group
                v-if="item.type === 'radio'"
                v-model="form[item.field]"
                :disabled="disabled(item.field)"
                class="custom-input"
              >
                <el-radio
                  v-for="option in item.options"
                  :key="option.code"
                  :label="option.code"
                >{{ option.text }}</el-radio>
              </el-radio-group>
              <!-- 多选框 -->
              <el-checkbox-group
                v-if="item.type === 'checkbox'"
                v-model="form[item.field]"
                class="custom-input"
              >
                <el-checkbox
                  v-for="option in item.options"
                  :key="option.code"
                  :label="option.code"
                >{{ option.text }}</el-checkbox>
              </el-checkbox-group>
              
              <el-upload v-if="item.type === 'img'"
                  :ref="el => setUploadRef(el, item.field)"
                  class="upload-demo"
                  :action="reqURL.fileUpload"
                  :headers="{ 'token': loginUserInfo.token }"
                  :accept="item.accept || '.jpg,.png'"
                  multiple = "false"
                  :on-success="(response, file) => uploadSuccess(response, file, item.field)"
                  :limit="1"
                  :show-file-list="false"
              >
                  <el-input
                    v-model="form[item.field + 'Name']"
                    disabled="true"
                    class="custom-input"
                  ></el-input>
                  <el-button v-if="!disabled(item.field)" type="primary">{{ $t('common.buttons.upload')}}</el-button>
                </el-upload>
            </el-form-item>
          </el-col>
        </template>
      </el-row>
      <el-row style="justify-content: center;padding: 10px;">
        <!-- 插槽：动态按钮 -->
        <slot name="items"></slot>
      </el-row>
      <el-row style="justify-content: center;margin-top: 20px;">
        <!-- 插槽：动态按钮 -->
        <slot name="buttons"></slot>
      </el-row>
  </el-form>
</template>

<script setup>
import { ref, computed, defineProps, defineExpose } from 'vue';
import { ElMessage } from 'element-plus'
import { reqURL } from '@/utils/urls.js'
const props = defineProps({
  // 接收父组件传递的表单项配置
  formItems: {
    type: Array,
    required: true,
  },
  formDatas: {
    type: Object,
    required: false
  },
  disabledItems: {
    type: Array,
    required: false,
  },
  labelWidth: {
    type: String,
    required: false
  },
});
const uploadRefs = ref({});
function setUploadRef(el, field) {
  if (el) uploadRefs.value[field] = el;
}
const loginUserInfo = JSON.parse(localStorage.getItem('userInfo'));
// 表单数据
const form = computed(() => {
  return props.formDatas;
});
// 动态生成验证规则
const rules = computed(() => {
  const rules = {};
  props.formItems.forEach((item) => {
    if (item.rules) {
      rules[item.field] = item.rules;
    }
  });
  return rules;
});
// 表单项
const dynamicFormRows = computed(() => {
  return props.formItems;
});

const disabled = (field)=> {
  if (props.disabledItems) {
    if (props.disabledItems.includes('*')) {
        return true; 
    } else {
        return props.disabledItems.includes(field)
    }
  } else {
    return false;
  }
};

const uploadSuccess = async (response, file, field) => {
  try {
    if (response.retCode == 1) {
      form.value[field] = response.data.fileId;
      form.value[field + 'Name'] = response.data.fileName;
    } else {
      ElMessage.error(response.retMsg)
    }
  } finally {
      uploadRefs.value[field]?.clearFiles?.()
  }
}

// 表单引用
const formRef = ref(null);

// 重置表单
const reset = () => {
  formRef.value.resetFields();
  formRef.value.clearValidate()
};
// 验证表单
const valid = async()=> {
  try {
    await formRef.value.validate();
    return true;
  } catch (error) {
    console.error('Validation failed:', error);
    return false;
  }
};

const validateField = async(formItem)=> {
  try {
    await formRef.value.validateField(formItem);
    return true;
  } catch (error) {
    console.error('Validation failed:', error);
    return false;
  }
};
// 获取表单数据
const getFormData = async(validFlag) => {
  if (validFlag == undefined || validFlag == true) {
    const isValid = await valid();
    if (isValid) {
      return form;
    } else {
      ElMessage.error('信息有误，请检查！');
    }
  } else {
    return form;
  }
};
// 暴露方法给父组件
defineExpose({
  getFormData,
  reset,
  valid,
  validateField
});

</script>

<style scoped>

.form-item {
  padding: 10px;
}
.custom-input {
  width: 100%;
  max-width: 350px;
  text-align: left;
}
/* 隐藏增减按钮 */
.custom-input-number :deep(.el-input-number__decrease),
.custom-input-number :deep(.el-input-number__increase) {
  display: none;
}

/* 调整输入框宽度 */
.custom-input-number :deep(.el-input__inner) {
  width: 100%;
  max-width: 350px;
  text-align: center; /* 文本左对齐 */
}

:deep(.el-tag) {
  max-width: none !important;
}

</style>